<template>
  <div>
    <!-- Tab Navigation -->
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/mch/anc_treatment/anc-profile/' + $route.params.visit_id"
        :class="[
          'tab-link',
          $route.fullPath ==
          '/mch/anc_treatment/anc-profile/' + $route.params.visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🧍‍♀️📋 Antenatal Profile
      </a>

      <a
        :href="'/mch/anc_treatment/present-pregnancy'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/present-pregnancy'
            ? 'active-tab'
            : '',
        ]"
      >
        🔄 Labor progress
      </a>

      <a
        :href="'/mch/anc_treatment/investigations'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/investigations'
            ? 'active-tab'
            : '',
        ]"
      >
        🔬 Investigations & Lab Results
      </a>

      <a
        :href="'/mch/anc_treatment/weight-monitoring'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/weight-monitoring'
            ? 'active-tab'
            : '',
        ]"
      >
        ➡️👶 Delivery
      </a>

      <a
        :href="'/mch/anc_treatment/tetanus-injections'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/tetanus-injections'
            ? 'active-tab'
            : '',
        ]"
      >
        👶 Newborn Information
      </a>

      <a
        :href="'/mch/anc_treatment/medical-history'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/medical-history'
            ? 'active-tab'
            : '',
        ]"
      >
        🤱 Immediate Postpartum
      </a>

      <a
        :href="'/mch/anc_treatment/medical-history'"
        :class="[
          'tab-link',
          $route.fullPath == '/mch/anc_treatment/medical-history'
            ? 'active-tab'
            : '',
        ]"
      >
        🛏️ Bed/Ward Assignment
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ancindex",
  methods: {
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
body {
  font-family: "Inter", sans-serif;
}

/* Base tab link styling */
.tab-link {
  display: inline-block;
  padding: 8px 16px;
  background-color: white;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Hover effect */
.tab-link:hover {
  background-color: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
  transform: translateY(-1px);
}

/* Active tab */
.active-tab {
  background-color: #1d4ed8;
  color: white !important;
  border-color: #1d4ed8;
  box-shadow: 0 2px 4px rgba(29, 78, 216, 0.25);
  transform: translateY(-1px);
}

/* Optional: subtle transition for layout */
div[style*="flex-wrap"] {
  transition: background 0.3s ease;
}
</style>
